<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="12"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-expansion-panels
              v-model="panel"
              multiple
            >
              <v-expansion-panel>
                <v-expansion-panel-header>WHOIS</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pre>{{ whois }}</pre>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>DNS</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="ns-records"><h4>A records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.a">{{ item }}</li>
                    </ul>
                  </div>
                  <div class="ns-records"><h4>MX records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.mx">{{ item }}</li>
                    </ul>
                  </div>
                  <div class="ns-records"><h4>TXT records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.txt">{{ item }}</li>
                    </ul>
                  </div>
                  <div class="ns-records"><h4>NS records:</h4>
                    <ul>
                      <li :key="index" v-for="(item, index) in dns.ns">{{ item }}</li>
                    </ul>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>DOCTOR - status: <span v-html="doctorStatus"></span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-menu
                    v-for="(menu, index) in menus"
                    :key="index"
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ menu.command_category_title }}
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="(command, index) in menu.commands"
                        :key="index"
                      >
                        <v-list-item-title>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                @click="triggerCommand(command.id, command.command_exra_params)"
                              >
                                {{ command.command_name }}
                              </span>
                            </template>
                            <span>{{ command.command_desc }}</span>
                          </v-tooltip>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-card>
                    <div class="server-console" v-html="consoleLog" ref="serverConsole"></div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-form>
      <v-dialog
        v-model="commandDialog"
        width="1024"
      >
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-row v-for="(inputField, index) in inputFields" :key="index">
                  <v-col cols="12">
                    <v-text-field
                      :label="inputField.field_name"
                      v-model="commandParams[inputField.field_name]"
                      @keyup.enter="triggerCommandWithParams()"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              @click="commandDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="triggerCommandWithParams()"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AgentDoctor',
  components: {
  },
  created() {
    this.uid = this.$store.state.user.id;
    this.tid = this.$route.params.tid;
    this.domain = this.$route.params.domain;
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    this.uuid = `${this.uid}_${this.tid}_${this.domain}_${yyyy}-${mm}-${dd}`;
    this.$api.post('agent/whois', {
      domain: this.domain,
    }).then((response) => {
      const respData = response.data;
      if (respData.is_error === false) {
        this.whois = respData.whois;
      }
    }).catch((error) => {
      if (error.response) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: error.response.data.message || error.response.data,
        });
      }
    });
    this.$api.post('agent/dns-lookup', {
      domain: this.domain,
    }).then((response) => {
      const respData = response.data;
      if (respData.is_error === false) {
        this.dns = respData.message;
        this.$api.post('agent/server-lookup', {
          domain: this.domain,
          dns: this.dns,
        }).then((subresponse) => {
          const subRespData = subresponse.data;
          if (subRespData.is_error === false) {
            this.hostname = subRespData.hostname;
            this.doctorStatus = '<span style="color:green">ready</span>';
            this.panel.push(2);
            this.triggerCommand(36, []);
            setTimeout(() => {
              this.triggerCommand(99, []);
            }, 500);
          } else {
            this.doctorStatus = '<span style="color:red">server lookup fail</span>';
          }
        });
      }
    }).catch((error) => {
      if (error.response) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: error.response.data.message || error.response.data,
        });
      }
    });
    this.$api.post('agent/get-command-menus', {
    }).then((response) => {
      const respData = response.data;
      if (respData.is_error === false) {
        this.menus = respData.command_tree;
      }
    }).catch((error) => {
      if (error.response) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: error.response.data.message || error.response.data,
        });
      }
    });
    this.getCommandHistory(); // Call once immediately
    this.timer = setInterval(this.getCommandHistory, 5000);
  },
  /* eslint-disable */
  mounted() {
    this.$nextTick(() => {
      // Copy button
      this.$refs['serverConsole'].addEventListener('click', (e) => {
        if (e.target.classList.contains('btn-copy')) {
          copyTextToClipboard(e.target.previousElementSibling.innerText);
        }

        function fallbackCopyTextToClipboard(text) {
          var textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
          } catch (err) {
          }

          document.body.removeChild(textArea);
        }

        function copyTextToClipboard(text) {
          if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
          }
          navigator.clipboard.writeText(text).then(function () {
          }, function (err) {
          });
        }
      });

      // Clickable response
      this.$refs['serverConsole'].addEventListener('click', (e) => {
        let cmd = e.target.getAttribute('data-cmd'),
          param = e.target.getAttribute('data-param');

        if (cmd && param) {
          e.preventDefault();
          console.log(cmd);
          console.log(param);
        }
      });
    });
  },
  /* eslint-enable */
  data() {
    return {
      doctorStatus: '<span style="color:orange">server lookup</span>',
      uid: '',
      tid: '',
      uuid: '',
      panel: [2],
      processing: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      valid: false,
      ticket: '',
      domain: '',
      purpose: '',
      form: {
      },
      whois: '',
      dns: [],
      menus: [],
      inputFields: [],
      hostname: '',
      commandId: '',
      commandDialog: false,
      commandParams: {},
      timer: null,
      consoleLog: '',
      commandHistory: null,
      historyId: 0,
    };
  },
  beforeDestroy() {
    // Cleanup when component is destroyed
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    triggerCommand(commandId, commandParams) {
      this.commandId = commandId;
      if (!Array.isArray(commandParams)) {
        this.$underscore.each(commandParams, (val, key) => {
          console.log(val, key); // eslint-disable-line no-console
          if (val === 'input[text]') {
            this.inputFields.push({
              field_name: key,
              type: val,
            });
          }
        });
        this.commandDialog = true;
      } else {
        const now = new Date();
        const singaporeTime = now.toLocaleString('en-US', {
          timeZone: 'Asia/Singapore',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).replace(/(\d+)\/(\d+)\/(\d+), (\d+:\d+:\d+)/, '$3-$1-$2 $4');
        this.$underscore.each(this.menus, (menu) => {
          this.$underscore.each(menu.commands, (command) => {
            if (command.id === this.commandId) {
              this.consoleLog += `<p class="text-command" style="color:#fff;">[${singaporeTime}]
send command ${command.command_name}</p>`;
            }
          });
        });
        this.$api.post('agent/fire-command', {
          uuid: this.uuid,
          cid: commandId,
          cparams: {
            domain: this.domain,
          },
          hostname: this.hostname,
        }).catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message || error.response.data,
            });
          }
        }).finally(() => {
          this.commandDialog = false;
        });
      }
    },
    triggerCommandWithParams() {
      const now = new Date();
      const singaporeTime = now.toLocaleString('en-US', {
        timeZone: 'Asia/Singapore',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).replace(/(\d+)\/(\d+)\/(\d+), (\d+:\d+:\d+)/, '$3-$1-$2 $4');
      this.$underscore.each(this.menus, (menu) => {
        this.$underscore.each(menu.commands, (command) => {
          if (command.id === this.commandId) {
            this.consoleLog += `<p class="text-command" style="color:#fff;">[${singaporeTime}]
send command ${command.command_name}</p>`;
          }
        });
      });
      this.commandParams.domain = this.domain;
      this.$api.post('agent/fire-command', {
        uuid: this.uuid,
        cid: this.commandId,
        cparams: this.commandParams,
        hostname: this.hostname,
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        }
      }).finally(() => {
        this.commandDialog = false;
      });
    },
    getCommandHistory() {
      this.$api.post('agent/get-command-history', {
        uuid: this.uuid,
        hid: this.historyId,
      }).then((response) => {
        const respData = response.data;
        if (respData.is_error === false) {
          this.commandHistory = respData.command_history;
          const extraContent = '<a href="javascript:void(0)" class="btn btn-success btn-xs btn-copy">Copy</a>';
          this.commandHistory.forEach((commandRow) => {
            const prefix = '\u001b[1;32m';
            const logHtml = commandRow.data
              .split(/(?:\r\n|\r|\n)/g)
              .map((x) => prefix + x)
              .map((x) => window.ansiUp.ansi_to_html(x))
              .map((x) => this.parseResponse(x))
              .join('<br/>');

            this.consoleLog += `<p class="text-success">[${commandRow.created_at}]
receive response from server:<br><pre>${logHtml}</pre>${extraContent}</p>`;
            this.$nextTick(() => {
              this.$refs.serverConsole.scrollTop = this.$refs.serverConsole.scrollHeight;
            });
            if (commandRow.id > this.historyId) {
              this.historyId = commandRow.id;
            }
          });
        }
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        }
      });
    },
    /* eslint-disable */
    addColor(responseText) {

    },
    parseResponse(responseText) {
      let cmdLeftTag = '\u2AF7',
        cmdRightTag = '\u2AF8',
        tagLength = 1,
        startPos = 0,
        stop = false,
        textParts = [];

      do {
        let cmdLeftOpen = responseText.search(cmdLeftTag),
          cmdRightOpen = responseText.search(cmdRightTag);

        if (cmdLeftOpen < 0 || cmdRightOpen < 0) {
          textParts.push(responseText);
          stop = false;
          break;
        }

        let openTag = responseText.substring(cmdLeftOpen, cmdRightOpen + tagLength);
        let cmdClose = responseText.substring(cmdRightOpen + tagLength).search(openTag);

        if (cmdClose < 0) {
          textParts.push(responseText);
          stop = false;
          break;
        }

        textParts.push(responseText.substring(startPos, cmdLeftOpen));
        responseText = responseText.substring(cmdRightOpen + tagLength);
        let parameter = responseText.substring(0, cmdClose);
        let cmdId = openTag.substring(1, openTag.length - 1);
        let param = parameter.replace('"', "&#34;");

        textParts.push('<a href="#"');
        textParts.push(' data-cmd="' + cmdId + '"');
        textParts.push(' data-param="' + param + '"');
        textParts.push('>');
        textParts.push(parameter);
        textParts.push('</a>');

        responseText = responseText.substring(cmdClose + openTag.length);

      } while (stop === false);

      return textParts.join('');
    },
    /* eslint-enable */
  },
};
</script>

<style scoped>
.server-console {
  height: 512px;
  max-width: 5120px;
  overflow: auto;
  border: 1px solid lightgrey;
  padding: 15px;
}

.server-console {
  background-color: #000;
}

.server-console pre {
  background-color: black;
  color: rgb(0, 255, 0);
  border: 0;
  padding: 0;
  margin: 0;
}

.server-console a {
  text-decoration: underline;
}

.text-command {
  color: #fff;
}

.server-console .text-success {
  color: #00bb00;
}

.btn-copy {
  color: #fff;
  background-color: #20895e;
  border-color: #196c4b;
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
